import { render, staticRenderFns } from "./yiliaofuwu_hjxtpz.vue?vue&type=template&id=d6d4b80c&scoped=true"
import script from "./yiliaofuwu_hjxtpz.vue?vue&type=script&lang=js"
export * from "./yiliaofuwu_hjxtpz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d4b80c",
  null
  
)

export default component.exports